// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8ypEo","bgImg":"styles_bgImg__1qaQe","dynamicTextImage":"styles_dynamicTextImage__2wqJC"};